import { ButtonAction } from "../Views/MiscButton";
import { Constants } from "./Constants";
import { ToggleButtonAction } from "../Views/ToggleButton";
import { MiscButtonsContainer } from "../Views/MiscButtonsContainer";
import { Client } from "@core/Client";

/**
 * Specific preset actions without TOGGLE_PRESETS_VISIBILITY event emitter
 * Due to not using the presets window anymore and we do not have to close anything
 * If calling the presets from the preset windwo then TOGGLE_PRESETS_VISIBILITY must be emitted
 */
export class ButtonZeroGame implements ButtonAction {
	constructor(private buttonIndex: number) {

	}

	Action(): void {
		if (Client.logic.IsBoard) {
			Client.logic.ZerroGame()
		} else {
			//firstly logic of "radio button"
			Client.game.events.emit(Constants.EVENTS.TOGGLE_RADIOBUTTONS, this.buttonIndex);
			//Setting wide bet for place bet logic!
			Client.game.events.emit(Constants.EVENTS.SET_WIDE_BET, this.buttonIndex);
		}
	}
}

export class ButtonBigSeries implements ButtonAction {
	constructor(private buttonIndex: number) {

	}

	Action(): void {
		if (Client.logic.IsBoard) {
			Client.logic.BigSeries()
		} else {
			//firstly logic of "radio button"
			Client.game.events.emit(Constants.EVENTS.TOGGLE_RADIOBUTTONS, this.buttonIndex);
			//Setting wide bet for place bet logic!
			Client.game.events.emit(Constants.EVENTS.SET_WIDE_BET, this.buttonIndex);
		}
	}
}

export class ButtonOrphans implements ButtonAction {
	constructor(private buttonIndex: number) {

	}

	Action(): void {
		if (Client.logic.IsBoard) {
			Client.logic.Orphans()
		} else {
			//firstly logic of "radio button"
			Client.game.events.emit(Constants.EVENTS.TOGGLE_RADIOBUTTONS, this.buttonIndex);
			//Setting wide bet for place bet logic!
			Client.game.events.emit(Constants.EVENTS.SET_WIDE_BET, this.buttonIndex);
		}
	}
}

export class ButtonSmallSeries implements ButtonAction {
	constructor(private buttonIndex: number) {

	}

	Action(): void {
		if (Client.logic.IsBoard) {
			Client.logic.SmallSeries();
		}
		else {
			//firstly logic of "radio button"
			Client.game.events.emit(Constants.EVENTS.TOGGLE_RADIOBUTTONS, this.buttonIndex);
			//Setting wide bet for place bet logic!
			Client.game.events.emit(Constants.EVENTS.SET_WIDE_BET, this.buttonIndex);
		}
	}
}

export class Button1 implements ButtonAction {
	constructor(private buttonIndex: number) {

	}

	Action(): void {
		if (Client.logic.IsBoard) {
			Client.logic.ZerroGame()
			Client.game.events.emit("TOGGLE_PRESETS_VISIBILITY")
		} else {
			//firstly logic of "radio button"
			Client.game.events.emit(Constants.EVENTS.TOGGLE_RADIOBUTTONS, this.buttonIndex);
			//Setting wide bet for place bet logic!
			Client.game.events.emit(Constants.EVENTS.SET_WIDE_BET, this.buttonIndex);
			Client.game.events.emit("TOGGLE_PRESETS_VISIBILITY")
		}
	}
}

export class Button2 implements ButtonAction {
	constructor(private buttonIndex: number) {

	}

	Action(): void {
		if (Client.logic.IsBoard) {
			Client.logic.BigSeries()
			Client.game.events.emit("TOGGLE_PRESETS_VISIBILITY")
		} else {
			//firstly logic of "radio button"
			Client.game.events.emit(Constants.EVENTS.TOGGLE_RADIOBUTTONS, this.buttonIndex);
			//Setting wide bet for place bet logic!
			Client.game.events.emit(Constants.EVENTS.SET_WIDE_BET, this.buttonIndex);
			Client.game.events.emit("TOGGLE_PRESETS_VISIBILITY")
		}
	}
}

export class Button3 implements ButtonAction {
	constructor(private buttonIndex: number) {

	}

	Action(): void {
		if (Client.logic.IsBoard) {
			Client.logic.Orphans()
			Client.game.events.emit("TOGGLE_PRESETS_VISIBILITY")
		} else {
			//firstly logic of "radio button"
			Client.game.events.emit(Constants.EVENTS.TOGGLE_RADIOBUTTONS, this.buttonIndex);
			//Setting wide bet for place bet logic!
			Client.game.events.emit(Constants.EVENTS.SET_WIDE_BET, this.buttonIndex);
			Client.game.events.emit("TOGGLE_PRESETS_VISIBILITY")
		}
	}
}

export class Button4 implements ButtonAction {
	constructor(private buttonIndex: number) {

	}

	Action(): void {
		if (Client.logic.IsBoard) {
			Client.logic.SmallSeries();
			Client.game.events.emit("TOGGLE_PRESETS_VISIBILITY")
		}
		else {
			//firstly logic of "radio button"
			Client.game.events.emit(Constants.EVENTS.TOGGLE_RADIOBUTTONS, this.buttonIndex);
			//Setting wide bet for place bet logic!
			Client.game.events.emit(Constants.EVENTS.SET_WIDE_BET, this.buttonIndex);
			Client.game.events.emit("TOGGLE_PRESETS_VISIBILITY")
		}
	}
}

export class TogglePresetPanel implements ToggleButtonAction {
	constructor(private owner: MiscButtonsContainer) {

	}

	Action(): void {
		this.owner.TogglePresetsVisibility();
	}
}

export class Finali implements ButtonAction {
	constructor(private owner: MiscButtonsContainer) {

	}

	Action(): void {
		Client.logic.Finali();
		this.owner.TogglePresetsVisibility();
		this.owner.ResetToggleButton();
	}
}

export class RedSplit implements ButtonAction {
	constructor(private owner: MiscButtonsContainer) {

	}

	Action(): void {
		Client.logic.RedSplit();
		this.owner.TogglePresetsVisibility();
		this.owner.ResetToggleButton();
	}
}

export class BlackSplit implements ButtonAction {
	constructor(private owner: MiscButtonsContainer) {

	}

	Action(): void {
		Client.logic.BlackSplit();
		this.owner.TogglePresetsVisibility();
		this.owner.ResetToggleButton();
	}
}

export class HotNumbers implements ButtonAction {
	constructor(private owner: MiscButtonsContainer) {

	}

	Action(): void {
		Client.logic.HotNumbers();
		this.owner.TogglePresetsVisibility();
		this.owner.ResetToggleButton();
	}
}

export class RedSnake implements ButtonAction {
	constructor(private owner: MiscButtonsContainer) {

	}

	Action(): void {
		Client.logic.RedSnake();
		this.owner.TogglePresetsVisibility();
		this.owner.ResetToggleButton();
	}
}

export class PrisonBets implements ButtonAction {
	constructor(private owner: MiscButtonsContainer) {

	}

	Action(): void {
		Client.logic.PrisonBets();
		this.owner.TogglePresetsVisibility();
		this.owner.ResetToggleButton();
	}
}

export class MagicRing implements ButtonAction {
	constructor(private owner: MiscButtonsContainer) {

	}

	Action(): void {
		Client.logic.MagicRing();
		this.owner.TogglePresetsVisibility();
		this.owner.ResetToggleButton();
	}
}

export class ColdNumbers implements ButtonAction {
	constructor(private owner: MiscButtonsContainer) {

	}

	Action(): void {
		Client.logic.ColdNumbers();
		this.owner.TogglePresetsVisibility();
		this.owner.ResetToggleButton();
	}
}

export class NeighbourBet implements ButtonAction {
	constructor() {

	}

	Action(): void {
		Client.logic.NeighborsBet();
	}
}

export class RepeatBets implements ButtonAction {
	constructor() {

	}

	Action(): void {
		Client.logic.RepeatBetsLastGame()
	}
}

export class UndoBet implements ButtonAction {
	constructor() {

	}

	Action(): void {
		Client.logic.UndoAction()
	}
}

export class RedLeftTrack implements ButtonAction {
	constructor() {

	}

	Action(): void {
		Client.logic.RedLeftTrack()
	}
}

export class BlackLeftTrack implements ButtonAction {
	constructor() {

	}

	Action(): void {
		Client.logic.BlackLeftTrack()
	}
}

export class RedRightTrack implements ButtonAction {
	constructor() {

	}

	Action(): void {
		Client.logic.RedRightTrack()
	}
}

export class BlackRightTrack implements ButtonAction {
	constructor() {

	}

	Action(): void {
		Client.logic.BlackRightTrack()
	}
}